/**
 * Where Learn's card rests (the deck's, which the summary card overlays exactly), in the
 * coordinates of the cards' layer. In portrait that layer starts at the bottom of Learn's toolbar.
 */
export type LearnMapCardFrame = { bottom: number; top: number };

/** Before the deck has measured its card, the chrome it passes over fades across this stretch. */
const FALLBACK_COVERED_FADE = { end: 0.4, start: 0.1 } as const;

/** The chrome the card passes over fades out across at most this much of the slide. */
const COVERED_FADE_SPAN = 0.3;

/**
 * How far Learn's card has travelled up at `progress` (0 with the cards, 1 with the map): the
 * window's height, so it ends wholly above the screen from wherever it rests.
 */
export function learnMapCardTravel(progress: number, windowHeight: number): number {
  "worklet";
  return progress * windowHeight;
}

/**
 * 0 to 1: how far the chrome the card slides over (Learn's toolbar row, and the cards' backdrop
 * beneath the map) has faded out at `progress`. It fades only while the card covers the whole
 * toolbar row: from when the card's top passes the row's top until, at the latest, its bottom
 * passes the row's bottom. Learn's buttons are never seen fading, and the map's own are in their
 * place by the time the card uncovers them.
 */
export function learnMapCoveredFade(
  progress: number,
  cardFrame: LearnMapCardFrame | null,
  toolbarRowHeight: number,
  windowHeight: number,
): number {
  "worklet";
  let start: number = FALLBACK_COVERED_FADE.start;
  let end: number = FALLBACK_COVERED_FADE.end;
  if (cardFrame !== null && windowHeight > 0) {
    start = (cardFrame.top + toolbarRowHeight) / windowHeight;
    end = Math.min(cardFrame.bottom / windowHeight, start + COVERED_FADE_SPAN);
  }
  if (end <= start) {
    return progress >= start ? 1 : 0;
  }
  return Math.min(1, Math.max(0, (progress - start) / (end - start)));
}
